/*
 * Javier Quevedo-Fernandez
 * Copyright Ranj Games. 2013
 */

import ArrayIterator from "./datastructures/array/ArrayIterator";

/*
 * Returns the last item of the array
 * without removing it
 * @returns {Object} item
 */
Array.prototype.peek = function() {
    if (this.length > 0)
        return this[this.length - 1];
};

/*
 * 
 * @param {type} index
 * @param {type} item
 * @returns {undefined}
 */
Array.prototype.insert = function(index, item) {
    this.splice(index, 0, item);
};

/**
 * Removes the first occurence of an element in an Array
 * @param {*} item The item to remove
 * @returns {undefined} true if the element was found and removed, false otherwise
 */
Array.prototype.remove = function(item) {
    var index = this.indexOf(item);
    return this.removeAt(index);
};

/**
 * Removes the element at given index  in an Array
 * @param {*} index The index to remove
 * @returns {undefined} true if the element was found and removed, false otherwise
 */
Array.prototype.removeAt = function(index) {
    if (index > -1) {
        this.splice(index, 1);
        return true;
    }
    return false;
};

/**
 * Empties the array.
 */
Array.prototype.clear = function() {
    this.length = 0;
};

/**
 * Returns whether the array contains a certain element
 * @param {*} item
 * @returns {Boolean}
 */
Array.prototype.contains = function(item) {
    return this.indexOf(item) > -1;
};

/**
 * Returns whether the array contains any of the given elements
 * @param {[*]} itemArray
 * @returns {Boolean}
 */
Array.prototype.containsAny = function(itemArray) {
    for (var i = 0; i < itemArray.length; ++i) {
        if (this.contains(itemArray[i])) {
            return true;
        }
    }
    return false;
};

/**
 * Returns whether the array contains all of the given elements
 * @param {[*]} itemArray
 * @returns {Boolean}
 */
Array.prototype.containsAll = function(itemArray) {
    for (var i = 0; i < itemArray.length; ++i) {
        if (!this.contains(itemArray[i])) {
            return false;
        }
    }
    return true;
};

/**
 * Returns a clone of the array
 * @returns {Array}
 */
Array.prototype.clone = function() {
    var clone = [];
    for (var i = 0; i < this.length; i++) {
        var object = this[i];
        clone.push(object);
    }
    return clone;
};

/**
 * Get an iterator for this array
 * @returns {ArrayIterator}
 */
Array.prototype.getIterator = function() {
    return new ArrayIterator(this);
};

/**
 * Add an element to the end of the array
 * @param {type} item
 * @returns {undefined}
 */
Array.prototype.add = function(item) {
    this.push(item);
};

/**
 * Adds all elements from the given array to the end of this array
 * @param {Array} array
 * @returns {undefined}
 */
Array.prototype.addAll = function(array) {
    Array.prototype.push.apply(this, array);
};

/* Returns the difference between the calling array and a given one
 * Example: 
 * [1,2,3,4,5,6].diff( [3,4,5] );  
 * => [1, 2, 6]
 * @param {Array} a
 * @returns {Array}
 */
Array.prototype.diff = function(a) {
    return this.filter(function(i) {
        return !(a.indexOf(i) > -1);
    });
};

/**
 * Returns a shuffled version of this array.
 */
Array.prototype.shuffled = function() {
    var array = this.clone();
    var arrayShuffled = [];
    while (array.length > 0) {
        var index = Math.floor(Math.random() * array.length);
        arrayShuffled.push(array[index]);
        array.removeAt(index);
    }
    return arrayShuffled;
};